import React, { useContext, useEffect, useState } from "react";
import "./InventoryManagementIssue.css";
import { useRef } from "react";
import { Sorting } from "../../../../../components/Lists/Sorting";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
import Item from "../../../../../components/Lists/Item";
import { set } from "react-hook-form";
import { Radios } from "../../../../../components/RadioGroup/Radios";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../../contexts/DropdownsContext";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import {
  getEmployeesByLocation,
  issuePartsFromPartRequest,
} from "../../../Services/partRequestService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import { Tooltip } from "@mui/material";
import { getPartRequestInfoByPart } from "../../../Services/InventoryConfigurationService";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import Input from "../../../../../components/Inputs/Input";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import { use } from "react";
import FastPartRequest from "./FastPartRequest";
const IssuePartActions = ({ partRequestSelected, part, saveSuccess }) => {
  const [rackDrop, setRackDrop] = useState(null);
  const [employeeDrop, setEmployeeDrop] = useState(null);
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [forceDependency, setForceDependency] = useState([]);
  const [dataEmployeeDrop, setDataEmployeeDrop] = useState([]);
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const [cantToIssue, setCantToIssue] = useState(
    part?.orginalInfo?.quantity ?? 0
  );
  const hideFieldsWhenDisabled = new Set(["Rack"]);
  const [issueDetailToSelect, setIssueDetailToSelect] = useState(2);
  const dropdownIds = [79];
  const {
    dropdownsData,
    setDropdownsData,
    dropdownDefaultOptions,
    setDropdownIds,
  } = useContext(DropdownsContext);

  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const getEmployeesDropdownConfig = async () => {
    let dropdownId = 85;
    const request = await dropdownConfig(dropdownId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      const data = await getEmployeesByLocation(26);
      setDataEmployeeDrop(data.data.load);
      setEmployeeDrop(request.data.load);
    }
  };

  useEffect(() => {
    if (partRequestSelected) {
      getEmployeesDropdownConfig();
      setDropdownIds(dropdownIds);
      setForceDependency([
        {
          id: 25,
          parentSqlstatementColumnName: "id",
          childDropdownId: 79,
          childSqlstatementColumnName: "site_id",
          childSqlstatementParameterName: "siteId",
          contextId: 1,
          value: [partRequestSelected.SiteId],
        },
      ]);
    }
  }, [partRequestSelected]);

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) setDisplayDropdown(true);
  }, [dropdownsData]);
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const getEmployeeSelection = (selectedValues) => {
    setEmployeeSelected(selectedValues.id);
    setRackDrop(null);
  };
  const getRackSelection = (selectedValues) => {
    setRackDrop(selectedValues.id);
    setEmployeeSelected(null);
  };
  const getBestDetailId = (detailsIds, partInfo) => {
    const match = detailsIds.find(
      (detail) => detail.internalBatch === partInfo.internal_batch
    );
    if (match) return match;

    return detailsIds.reduce((min, current) => {
      return current.cantRquest < min.cantRquest ? current : min;
    }, detailsIds[0]);
  };
  const issueParts = async () => {
    if (!partRequestSelected) return;
    let partRequestInfo = partRequestSelected.orginalInfo;
    let partInfo = part.orginalInfo;
    let detailId = getBestDetailId(partRequestInfo.detailsIds, partInfo);
    const payload = {
      partRequestId: partRequestInfo.part_request_id,
      rackId: issueDetailToSelect == 1 ? rackDrop : null,
      employeeId: issueDetailToSelect == 2 ? employeeSelected : null,
      companyId: partInfo.company_id,
      details: [
        {
          id: detailId.id,
          serializedPartId: partInfo.serialized_part ?? null,
          siteId: partInfo.site_id,
          rackId: partInfo.rack_id,
          binId: partInfo.bin_id,
          shelfId: partInfo.shelf_id,
          locationId: partInfo.location_id,
          quantityToIssue: cantToIssue,
          partId: partInfo.part_id,
          companyId: partInfo.company_id,
          uomId: partInfo.uom_id,
          internalBatch: partInfo.internal_batch,
        },
      ],
    };
    issuePartsFromPartRequest([payload])
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
          successMsg("Parts Were issued successfully");
          saveSuccess();
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };
  const handleQTYToIssueChange = (e) => {
    const newQTY = e.target.value;
    setCantToIssue(newQTY);
  };
  return (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      {partRequestSelected && (
        <>
          <div className="issue-detail-cant">
            <b>QTY to issue</b>
            <Input
              name="quantity_issue"
              disableAutocomplete={true}
              placeholder={"Qty to Issue"}
              label={""}
              disabled={false}
              limit={part?.orginalInfo?.quantity}
              isNumeric={true}
              onChange={(e) => handleQTYToIssueChange(e)}
              value={cantToIssue}
            />
          </div>
          <div className="issue-detail">
            <Radios
              name="miGrupo"
              items={[
                { label: "Issue to Employee", value: 2 },
                { label: "Issue to Rack", value: 1 },
              ]}
              value={issueDetailToSelect}
              onChange={(val) => setIssueDetailToSelect(val)}
            />
          </div>
          <div style={{ width: "13vw" }}>
            {issueDetailToSelect == 1 ? (
              displayDropdown ? (
                <Dropdowns
                  context={{
                    dropdownsData,
                    setDropdownsData,
                    setDropdownIds,
                    dropdownDefaultOptions,
                  }}
                  required={true}
                  hideLabel={true}
                  placeholder={true}
                  forceDependency={forceDependency}
                  updateDropdown={updateDropdown}
                  resetDropdownsReload={resetDropdownsReload}
                  hideWhenDisabled={hideFieldsWhenDisabled.has("rackId")}
                  key={79}
                  onOptionSelect={(value, data) =>
                    getRackSelection(value, "rackId", data)
                  }
                  showPagination={false}
                  data={dropdownsData.find((e) => e.id === 79)}
                ></Dropdowns>
              ) : (
                <Skeleton height="2rem" width="80%" />
              ) //sites
            ) : employeeDrop ? (
              <Dropdowns
                onOptionSelect={getEmployeeSelection}
                updateDropdown={updateDropdown}
                resetDropdownsReload={resetDropdownsReload}
                staticDataColumnPreselection={"id"}
                isStatic={true}
                hideLabel={true}
                placeholder={true}
                staticData={dataEmployeeDrop}
                data={employeeDrop}
                required={true}
              ></Dropdowns>
            ) : (
              <Skeleton height="2rem" width="100%" />
            )}
          </div>
        </>
      )}
      <button
        className={`part-request-button-issue ${
          !partRequestSelected ||
          (issueDetailToSelect == 1 && !rackDrop) ||
          (issueDetailToSelect == 2) & !employeeSelected
            ? "disabled"
            : ""
        }`}
        onClick={() => issueParts()}
      >
        <div className="left-side">
          <i className="icon-issue"></i>
          <p>Part Issue </p>{" "}
        </div>
      </button>
    </div>
  );
};
const SearchBarContainer = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 1000); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};

export const InventoryManagementIssue = ({
  data,
  onClose,
  part,
  saveSuccess,
}) => {
  const [loadingParts, setLoadingParts] = useState(true);
  const listRef = useRef(null);
  const [maxPages, setMaxPages] = useState(null);
  const didMount = useRef(false);
  const loadListFirst = useRef(false);
  const [page, setPage] = useState(0);
  const [sortingOrder, setSortingOrder] = useState("part_request_id");
  const [search, setSearch] = useState("");
  const [formattedItems, setFormattedItems] = useState([]);
  const [partRequestSelected, setPartRequestSelected] = useState(null);
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const pageSize = 300;
  const [modeView, setModeView] = useState(1);
  const [onlyNewPartRequest, setOnlyNewPartRequest] = useState(false);
  const itemMapper = (item) => {
    return {
      id: item.part_request_id,
      ID: item.part_request_id,
      PRN: item.part_request_id,
      WP: item.work_package_id || "--",
      Company: item.company_name || "--",
      Location: item.pr_location_name || "--",
      Site: item.pr_site_name || "--",
      Aircraft: item.tail_number || "--",
      "Date Required": item.date_request_required
        ? item.date_request_required.split("T")[0]
        : "--",
      QTYReq: item.remaining_quantity || "--",
      SiteId: item.pr_site_id,
      orginalInfo: item,
    };
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, [formattedItems]);
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      if (!setLoadingParts) requestNextPage();
    }
  };
  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };
  const getSortingOrder = (order) => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    setSortingOrder(order);
  };
  useEffect(() => {
    if (!data || data.length === 0) {
      setOnlyNewPartRequest(true);
      setModeView(2);
      setLoadingParts(false);
      return;
    }

    const map = new Map();

    data.forEach((item) => {
      if (!item.remaining_quantity || item.remaining_quantity === 0) {
        return;
      }
      const key = JSON.stringify({
        part_request_id: item.part_request_id,
        pr_location_name: item.pr_location_name,
        pr_site_name: item.pr_site_name,
        pr_site_id: item.pr_site_id,
        tail_number: item.tail_number,
        work_package_id: item.work_package_id,
        date_request_required: item.date_request_required,
        company_name: item.company_name,
      });

      if (!map.has(key)) {
        map.set(key, {
          part_request_id: item.part_request_id,
          pr_location_name: item.pr_location_name,
          pr_site_name: item.pr_site_name,
          pr_site_id: item.pr_site_id,
          tail_number: item.tail_number,
          work_package_id: item.work_package_id,
          date_request_required: item.date_request_required,
          company_name: item.company_name,
          remaining_quantity: 0,
          detailsIds: [],
          referenceIds: new Set(),
        });
      }

      const group = map.get(key);
      group.remaining_quantity += item.remaining_quantity ?? 0;
      group.detailsIds.push({
        id: item.id,
        internalBatch: item.internal_batch,
        cantRquest: item.remaining_quantity,
      });
      group.referenceIds.add(item.reference_id);
    });

    let newArray = Array.from(map.values()).map((group) => ({
      ...group,
      referenceIds: Array.from(group.referenceIds),
    }));
    if (newArray.length === 0) {
      setOnlyNewPartRequest(true);
      setModeView(2);
    }
    setFormattedItems(
      newArray?.map((item, index) => {
        let mappedItem = itemMapper?.(item) ?? item;
        return { ...mappedItem, id: index };
      }) ?? []
    );
    setLoadingParts(false);
  }, [data]);

  useEffect(() => {
    if (!loadListFirst.current) {
      loadListFirst.current = true; // Evita la primera ejecución
      return;
    }
    setLoadingParts(true);
    getPartRequestInfoByPart(page, pageSize, search, sortingOrder, part.partId, part.internalBatch)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let data = response.data.load;
          if (!data || data.length === 0) return [];

          const map = new Map();

          data.forEach((item) => {
            if (!item.remaining_quantity || item.remaining_quantity === 0) {
              return;
            }
            const key = JSON.stringify({
              part_request_id: item.part_request_id,
              pr_location_name: item.pr_location_name,
              pr_site_name: item.pr_site_name,
              company_name: item.company_name,
              pr_site_id: item.pr_site_id,
              tail_number: item.tail_number,
              work_package_id: item.work_package_number,
              date_request_required: item.date_request_required,
            });

            if (!map.has(key)) {
              map.set(key, {
                part_request_id: item.part_request_id,
                pr_location_name: item.pr_location_name,
                pr_site_name: item.pr_site_name,
                pr_site_id: item.pr_site_id,
                tail_number: item.tail_number,
                work_package_id: item.work_package_number,
                company_name: item.company_name,
                date_request_required: item.date_request_required,
                remaining_quantity: 0,
                detailsIds: [],
                referenceIds: new Set(),
              });
            }

            const group = map.get(key);
            group.remaining_quantity += item.remaining_quantity ?? 0;
            group.detailsIds.push({
              id: item.id,
              internalBatch: item.internal_batch,
              cantRquest: item.remaining_quantity,
            });
            group.referenceIds.add(item.reference_id);
          });

          let newArray = Array.from(map.values()).map((group) => ({
            ...group,
            referenceIds: Array.from(group.referenceIds),
          }));
          setFormattedItems(
            newArray?.map((item, index) => {
              let mappedItem = itemMapper?.(item) ?? item;
              return { ...mappedItem, id: index };
            }) ?? []
          );
          setLoadingParts(false);
        }
      })
      .catch((error) => setLoadingParts(false));
  }, [page, search, sortingOrder]);
  const onChangeRadio = (value) => {
    const selectedItem = formattedItems.find(
      (item) => item.ID == Number(value)
    );
    setPartRequestSelected(selectedItem);
  };
  const handleSave = () => {
    saveSuccess();
    onClose();
  };
  return (
    <div className="inventory-management-issue-component">
      <div className="inventory-dialog-header">
        <div className="header-left-side">
          <div className="header-title">
            <i className="icon-issue"></i>
            <h2>Part Issue</h2>
          </div>
          <div className="header-part-info">
            <div className="header-part-info-data">
              <p>PN</p>
              <b>{part?.PN || "--"}</b>
            </div>
            <div className="header-part-info-data">
              <p>SN</p>
              <b>{part?.SN || "--"}</b>
            </div>
            <div className="header-part-info-data">
              <p>Batch</p>
              <b>{part?.Batch || "--"}</b>
            </div>
            <div className="header-part-info-data">
              <p>QTY</p>
              <b>{part?.QTY || "--"}</b>
            </div>
            <div className="header-part-info-data">
              <p>Location</p>
              <b>{part?.inventoryLocation || "--"}</b>
            </div>
          </div>
        </div>
        <button className="outlined icon small-size" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>
      </div>
      <hr />
      {!onlyNewPartRequest && (
        <div className="tab-view-selecction">
          <Radios
            name="miGrupo"
            items={[
              { label: "Existing Part Request", value: 1 },
              { label: "New Part Request", value: 2 },
            ]}
            value={modeView}
            textAling="center"
            widthInfo="100%"
            onChange={(val) => setModeView(val)}
          />
        </div>
      )}
      {modeView == 1 ? (
        <>
          <div className="inventory-dialog-body-actions">
            <div className="inventory-dialog-body-actions">
              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  alignItems: "center",
                  width: "35%",
                }}
              >
                <h2>Part Request</h2>
                <div className="search-bar-input">
                  <SearchBarContainer onSearch={setSearch} />
                  <i className="icon-search"></i>
                </div>
              </div>
              <DropdownsProvider>
                <IssuePartActions
                  part={part}
                  partRequestSelected={partRequestSelected}
                  saveSuccess={handleSave}
                ></IssuePartActions>
              </DropdownsProvider>
            </div>
            <div className="sorting-header existing-list">
              <div className="sorting-free-slot"> </div>
              <Sorting
                onOrderChange={getSortingOrder}
                ignoreProperties={true}
        showHeaderOrder={true}
                properties={{
                  part_request_id: "PRN",
                  work_package_id: "WP",
                  company_name: "Company",
                  pr_location_name: "Location",
                  pr_site_name: "Site",
                  tail_number: "Aircraft",
                  date_request_required: "Date Required",
                  remaining_quantity: "QTY Required",
                }}
              ></Sorting>
            </div>
          </div>
          <div className="inventory-dialog-body">
            <div
              className="inventory-list existing-part-request-list"
              ref={listRef}
              onScroll={handleScroll}
            >
              {loadingParts ? (
                // Mostrar esqueletos mientras carga
                Array.from({ length: 7 }).map((_, idx) => (
                  <div key={idx} className="item-container-skeleton">
                    <Skeleton
                      style={{ borderRadius: "10px" }}
                      height="1.68rem"
                      width={40}
                    />
                    <div className="item-skeleton-content">
                      <Skeleton height={20} width="80%" />
                    </div>
                    <Skeleton height={30} width="7rem" />
                  </div>
                ))
              ) : formattedItems.length === 0 ? (
                <ResultsNotFound />
              ) : (
                <Radios
                  items={formattedItems.map((item, idx) => ({
                    value: item.ID,
                    item, // lo pasamos tal cual para usarlo luego
                  }))}
                  name="myRadio"
                  value={partRequestSelected?.ID ?? ""}
                  onChange={(value) => onChangeRadio(value)}
                  direction="column"
                  customRender={(radioItem, isSelected) => (
                    <div className="item-prn-radio-container">
                      {[
                        "PRN",
                        "WP",
                        "Company",
                        "Location",
                        "Site",
                        "Aircraft",
                        "Date Required",
                        "QTYReq",
                      ].map((label) => (
                        <div className="property" key={label}>
                          <Tooltip
                            title={
                              tooltips[`${radioItem.item.id}-${label}`]
                                ? radioItem.item[label]
                                : ""
                            }
                            arrow
                          >
                            <p
                              className="light-font"
                              ref={(el) => {
                                if (el) {
                                  propertyRefs.current[
                                    `${radioItem.item.id}-${label}`
                                  ] = el;
                                }
                              }}
                            >
                              {radioItem.item[label]}
                            </p>
                          </Tooltip>
                        </div>
                      ))}
                    </div>
                  )}
                />
              )}
            </div>
          </div>
        </>
      ) : (
        <DropdownsProvider>
          {" "}
          <FastPartRequest
            part={part}
            saveSuccess={handleSave}
          ></FastPartRequest>
        </DropdownsProvider>
      )}
    </div>
  );
};
